var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDanger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 67.347 95.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.302 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,16.2A3.222,3.222,0,0,0,53.2,13V5.7A3.222,3.222,0,0,0,50,2.5a3.159,3.159,0,0,0-3.2,3.2v7.2A3.182,3.182,0,0,0,50,16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6,18a3.314,3.314,0,0,0,2.8,1.6,3.167,3.167,0,0,0,1.6-.4,3.267,3.267,0,0,0,1.2-4.4L36.6,8.6a3.267,3.267,0,0,0-4.4-1.2A3.18,3.18,0,0,0,31,11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,19.1a3.167,3.167,0,0,0,1.6.4,3.314,3.314,0,0,0,2.8-1.6L69,11.7a3.225,3.225,0,1,0-5.6-3.2l-3.6,6.2A3.18,3.18,0,0,0,61,19.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(37.914 46.847) rotate(-89.496)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6,59.2h0a5.283,5.283,0,0,1,1.3.1A25.338,25.338,0,0,0,80.6,44l2.8-8.6a5.677,5.677,0,0,0-10.8-3.5l-2.8,8.7a14.081,14.081,0,0,1-8.6,8.9,17.019,17.019,0,0,1-5.9,1H44.7a19.857,19.857,0,0,1-6-1,14.324,14.324,0,0,1-8.6-8.9l-2.8-8.7a5.629,5.629,0,1,0-10.7,3.5L19.4,44A25.409,25.409,0,0,0,34.8,60.1c.9.3,1.8.5,2.7.8V82.3a3.244,3.244,0,0,0,3.3,3.2H46L57.6,64A9.063,9.063,0,0,1,65.6,59.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5,66.2a4.42,4.42,0,0,0-3.9-2.3h0a4.541,4.541,0,0,0-3.9,2.3L48.3,91a4.587,4.587,0,0,0,.1,4.4,4.288,4.288,0,0,0,3.8,2.2H79.1a4.288,4.288,0,0,0,3.8-2.2A4.587,4.587,0,0,0,83,91ZM64,74.9a1.99,1.99,0,0,1,1.6-.7,2.22,2.22,0,0,1,2.2,2.2v.3l-1.1,9a3.6,3.6,0,0,0-1.1-.2,3.083,3.083,0,0,0-1,.1l-1.1-9A2.052,2.052,0,0,1,64,74.9Zm1.7,16.8a2.2,2.2,0,1,1,2.2-2.2A2.22,2.22,0,0,1,65.7,91.7Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.8d5f49da.svg";
export { ForwardRef as ReactComponent };